<template>
  <div
    v-if="iconName"
    class="icon-details-svg-dl display-inline-flex flex-items-center"
    style="
      --button-margin-bottom: 0;
      --button-background: transparent;
      --button-hover-background: transparent;
      --button-hover-color: var(--fa-dk-blue);
      --button-active-color: var(--fa-dk-blue);
      --margin-bottom: 0;
      --padding-left: 0;
      gap: var(--spacing-4xs);
    "
  >
    <div style="--margin-bottom: 0">
      <button
        type="button"
        class="icon-action-download-svg flat compact display-inline-block padding-x-2xs"
        style="--button-color: var(--fa-navy)"
        aria-label="Download SVG File"
        data-balloon-pos="up"
        :disabled="downloadStarted"
        @click="downloadSVG"
      >
        <font-awesome-icon
          :icon="$v6.solid.faArrowToBottom"
          fixed-width
          size="lg"
        />
        <span class="sr-only">Download SVG file</span>
      </button>
    </div>
  </div>
</template>

<script>
  import { EventTrackingMixin } from 'app/mixins'
  import { downloadSVG } from 'app/views/icons/components/icons/details/utils'
  import { loadViggo } from 'app/viggo'
  import { DEFAULT_STYLING } from 'app/views/icons/defaults'

  export default {
    name: 'IconSvgDownload',

    mixins: [EventTrackingMixin],

    inject: ['currentVersion'],

    props: {
      canAccessIcon: {
        type: Boolean
      },
      canDownloadIcon: {
        type: Boolean,
        required: true
      },
      icon: {
        type: Object
      },
      isProIcon: {
        type: Boolean,
        required: true
      },
      isProUser: {
        type: Boolean,
        required: true
      },
      isUsingModal: {
        type: Boolean,
        required: true
      },
      isCustomIcon: {
        type: Boolean,
        required: true
      },
      styling: {
        type: Object
      }
    },

    data() {
      return {
        downloadStarted: false,
        viggo: null
      }
    },

    computed: {
      activeVersion() {
        return `${this.$releases.active.version}`
      },

      iconName() {
        return this.icon?.name
      }
    },

    methods: {
      async downloadSVG() {
        this.$emit('getSelectedAction', 'Downloading this Icon')

        this.downloadStarted = true

        if (this.canDownloadIcon) {
          try {
            this.viggo = await loadViggo()
          } catch (error) {
            throw new Error('Error loading viggo', error)
          }

          this.$posthog.capture('icon_download_button_click', {
            context: `${this.iconModalContext(this.isUsingModal)}`,
            icon_name: this.icon.name,
            icon_style: this.styling.style,
            icon_family: this.styling.family
          })

          downloadSVG(this.viggo, this.styling, DEFAULT_STYLING, this.icon, this.activeVersion, this.isCustomIcon)
        } else {
          this.purchaseFlowEvent('icon_download_button_click', {
            context: `${this.iconModalContext(this.isUsingModal)}`,
            icon_name: this.icon.name,
            icon_style: this.styling.style,
            icon_family: this.styling.family
          })

          this.$emit('openProIconModal')
        }

        this.downloadStarted = false
      }
    }
  }
</script>
